export function getUrl(medium: string) {
  return `https://pro.chakra-ui.com?utm_source=chakra-ui.com&utm_medium=${medium}`
}
